import type { IntelData } from "../lib/translate";
import { buildCommandCenterDataReadinessRows } from "../lib/commandCenterDataReadiness";

interface CommandCenterDataReadinessPanelProps {
  symbols: readonly string[];
  intelMap: Record<string, IntelData | undefined>;
}

const S = {
  wrap: {
    background: "rgba(12,12,24,0.85)",
    border: "1px solid rgba(255,255,255,0.06)",
    borderRadius: "8px",
    padding: "10px",
    marginBottom: "12px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    paddingBottom: "6px",
    marginBottom: "6px",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
  },
  title: {
    fontSize: "10px",
    fontWeight: 900,
    color: "#e2e8f0",
    letterSpacing: "0.08em",
    textTransform: "uppercase" as const,
  },
  note: {
    fontSize: "9px",
    color: "#94a3b8",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse" as const,
    fontSize: "10px",
  },
  th: {
    color: "#94a3b8",
    fontSize: "8px",
    fontWeight: 900,
    letterSpacing: "0.08em",
    textTransform: "uppercase" as const,
    textAlign: "left" as const,
    padding: "6px",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
  },
  td: {
    color: "#dbeafe",
    padding: "7px 6px",
    borderBottom: "1px solid rgba(255,255,255,0.05)",
  },
  symbol: {
    color: "#f8fafc",
    fontWeight: 900,
  },
};

export function CommandCenterDataReadinessPanel({ symbols, intelMap }: CommandCenterDataReadinessPanelProps) {
  const rows = buildCommandCenterDataReadinessRows(symbols, intelMap);
  return (
    <section style={S.wrap} aria-label="Command Center data readiness accountability">
      <div style={S.header}>
        <span style={S.title}>Command Center data readiness</span>
        <span style={S.note}>Accountability-only feed integrity; not a trading signal.</span>
      </div>
      <table style={S.table}>
        <thead>
          <tr>
            <th style={S.th}>Symbol</th>
            <th style={S.th}>Input integrity</th>
            <th style={S.th}>Feed freshness</th>
            <th style={S.th}>Status</th>
            <th style={S.th}>CTO action</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.symbol}>
              <td style={{ ...S.td, ...S.symbol }}>{row.symbol}</td>
              <td style={S.td}>{row.inputIntegrity}</td>
              <td style={S.td}>{row.feedFreshness}</td>
              <td style={S.td}>{row.dataStatus}</td>
              <td style={S.td}>{row.ctoAction}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
